import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Iconify, MultiDatePicker } from '..';
import { widgetIconButtonStyle, widgetButtonWrapperStyle } from '../../styles/widgetCounterStyle';

const WidgetButtons = ({ toggle, dateRangeProps, handleOpen, handleClose, type, tableTitle }) =>
    <Box sx={widgetButtonWrapperStyle} className={tableTitle === 'Aligner Approve Leads' ? 'widgetButtonWrapper' : ''}>
        <Tooltip title={toggle ? 'Collapse stats' : 'Expand stats'} arrow>
            <IconButton
                sx={widgetIconButtonStyle}
                onClick={toggle ? handleClose : handleOpen}
                className='widgetButton'
                size='small'
            >
                <Iconify
                    icon={toggle ? 'solar:alt-arrow-up-line-duotone' : 'solar:alt-arrow-down-outline'}
                    width={20}
                    height={20}
                />
            </IconButton>
        </Tooltip>
        {dateRangeProps && <MultiDatePicker
            value={dateRangeProps.date}
            endDate={new Date()}
            dateChange={dateRangeProps.dateChange}
            setValue={dateRangeProps.setDate}
            startDateValue={dateRangeProps.startDate}
            endDateValue={dateRangeProps.endDate}
            inputFieldType='button'
            type={type}
        />}
    </Box>;

export default WidgetButtons;

WidgetButtons.propTypes = {
    toggle: PropTypes.bool,
    handleOpen: PropTypes.func,
    handleClose: PropTypes.func,
    dateRangeProps: PropTypes.object,
    type: PropTypes.string,
    tableTitle: PropTypes.string,
};